import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HRRequestListInput, ImsDocumentsInputs, Procedures} from '../../models/input.model';

@Component({
  selector: 'app-pagination',
  imports: [],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.css'
})
export class PaginationComponent implements OnInit{

  @Input() params: {
    limit: number,
    offset: number
  } = {
    limit:  50,
    offset:  0
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.params.limit) || 0;
  }

  get currentPage(): number {
    return Math.floor(this.params.offset / this.params.limit) + 1;
  }

  @Input() totalItems: number = 0;
  @Output() pageChange: EventEmitter<any> = new EventEmitter<ImsDocumentsInputs | HRRequestListInput | Procedures>();

  ngOnInit() {
  }

  saveNewParams() {
    this.pageChange.emit(this.params);
    localStorage.setItem('paging', JSON.stringify({limit: this.params.limit,  offset:  0}));
  }

  nextPage() {
    this.params.offset += this.params.limit;
    this.saveNewParams()
  }

  prevPage() {
    this.params.offset -= this.params.limit;
    this.saveNewParams()
  }
  changeLimit(num: number) {
    this.params.offset = 0;
    this.params.limit = num;
    this.saveNewParams()
  }
}
